<template>
  <div class="container lnb d_container">
      <div class="contents_wrap">
          <div class="contents list-container">
              <div class="title">
                  레귤러 콘텐츠등록
              </div>
              <div class="list-content">
                  <regular-write-component :contentType="'regularCreate'" :streamingKey="streamingKey"></regular-write-component>

                  <div class="pa15 text-center btn_wrap">
                    <el-button type="save" @click="write">저장</el-button>
                    <el-button type="cancel" @click="$router.push('/streamingmanage/regularcontent')">목록</el-button>
                  </div>
              </div>
          </div>
          <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>

      </div>
  </div>
</template>

<script>
  import RegularWriteComponent from "@/components/content/RegularWriteComponent";
  import EventBus from "@/utils/event-bus";
  export default {

      name: 'RegularCreate',
      mixins: [],
      components: {RegularWriteComponent},
      provide() {
          return {}
      },
      props: {},
      data() {
          return {
            streamingKey:this.$route.params.s_idx,
          }
      },
      created() {
      },
      mounted() {
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      computed: {
      },
      methods: {
        write() {
          EventBus.$emit("writeRegular")
        },
      },
      watch: {},
  }
</script>
